export enum GroupType {
  Firm = 1,
  Groups = 2,
  Internal = 3,
  ExpertGeneralPool = 4,
}